import apiClient from '@shared/services/apiClient';
import type { PaginatedResult } from '@shared/types/api';
import type {
  DataQualitySummaryDto,
  DataQualityBadgeCountDto,
  DataQualityClinicListDto,
} from '../types/dataQuality';

export const dataQualityApi = {
  getSummary: async (): Promise<DataQualitySummaryDto> => {
    const response = await apiClient.get('/data-quality/summary');
    return response.data;
  },

  getBadgeCount: async (): Promise<DataQualityBadgeCountDto> => {
    const response = await apiClient.get('/data-quality/summary/count');
    return response.data;
  },

  getClinicsByCheck: async (
    checkId: string,
    page = 1,
    pageSize = 20,
    search?: string,
    sortColumn?: string,
    sortDirection?: string,
  ): Promise<PaginatedResult<DataQualityClinicListDto>> => {
    const params = new URLSearchParams({
      checkId,
      page: String(page),
      pageSize: String(pageSize),
    });
    if (search) params.append('search', search);
    if (sortColumn) params.append('sortColumn', sortColumn);
    if (sortDirection) params.append('sortDirection', sortDirection);
    const response = await apiClient.get(`/data-quality/clinics?${params}`);
    return response.data;
  },
};
